<script setup lang="ts">
interface Props {
  modelValue: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<(e: 'update:modelValue', value: boolean) => void>()

function toggle() {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue)
  }
}
</script>

<template>
    <button
        type="button"
        class="relative w-11 h-6 rounded-full transition-all duration-200"
        :class="[
            props.modelValue ? 'bg-[#2d5396]' : 'bg-[#d5ddea]',
            props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        ]"
        @click="toggle"
    >
        <span
            class="absolute top-0.5 w-5 h-5 rounded-full bg-white shadow-sm transition-all duration-200"
            :class="props.modelValue ? 'translate-x-5' : 'translate-x-0.5'"
        />
    </button>
</template>
